import React from 'react';
import { Loader2 } from 'lucide-react';
import './ImagingHeader.css';

// ImagingLoadingState renders the "fetching images" placeholder card
// shown while an imaging page is loading its initial data. It mirrors
// the visual structure of ImagingEmptyState (review-card wrapper,
// circular icon disc, title + description) so the page swaps cleanly
// from loading to empty/results without any layout shift. The icon
// spins via a locally-scoped keyframe so the component is drop-in and
// doesn't depend on Tailwind's animate-spin or a shared stylesheet.
function ImagingLoadingState({
    title = 'Loading images',
    description = 'Hang tight while we fetch your imaging studies.',
}) {
    return (
        <div className="review-card">
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '1rem',
                    textAlign: 'center',
                    padding: '2.5rem 2rem',
                }}
            >
                <div
                    style={{
                        borderRadius: '9999px',
                        backgroundColor: '#e5e7eb',
                        padding: '1.5rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Loader2
                        size={48}
                        strokeWidth={2}
                        color="#6b7280"
                        style={{ animation: 'imagingLoadingSpin 1s linear infinite' }}
                    />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', maxWidth: '28rem' }}>
                    <h2 style={{ fontSize: '1.5rem', fontWeight: 600, lineHeight: 1.25, margin: 0 }}>
                        {title}
                    </h2>
                    <p style={{ color: '#6b7280', margin: 0 }}>
                        {description}
                    </p>
                </div>
            </div>
            <style>{`
                @keyframes imagingLoadingSpin {
                    to { transform: rotate(360deg); }
                }
                @media (prefers-reduced-motion: reduce) {
                    [style*="imagingLoadingSpin"] {
                        animation: none !important;
                    }
                }
            `}</style>
        </div>
    );
}

export default ImagingLoadingState;
